<template>
  <b-modal
    id="identity-to-validate-modal"
    class="identity-to-validate-modal"
    ref="modal"
    @ok="handleSubmit"
    header-class="identity-to-validate-header"
    centered
    no-close-on-esc
    no-close-on-backdrop
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="identity-to-validate-header-content step4 w-100">
        <div class="identity-to-validate-container h-100">
          <h1 class="page-title ml-4 identity-to-validate-title" >{{$t('modal.identity.refused.title')}}</h1>
          <h1 class="page-title mt-4 ml-4 identity-to-validate-subtitle">{{$t('modal.identity.refused.subtitle')}}</h1>
        </div>
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="identity-to-validate-step-img margin-bottom-15" >
      </div>
    </template>

    <div>
      <div >
        <p class="identity-to-validate-text mt-2" v-html="$t('onboarding.need.identity')"></p>
        <p class="identity-to-validate-text mt-2" v-html="$t('onboarding.identity.wont.conserve')"></p>

        <b-form>
          <div class="row position-relative">
            <div class="col-md-12">
              <b-form-group
                :label="$t('Recto')"
                label-for="recto-input"
                :invalid-feedback="identity.recto.invalidFeedback"
                class="mb-4">
                <b-form-file
                  id="recto-input"
                  :browse-text="$t('Select')"
                  v-model="identity.recto.value"
                  :drop-placeholder="$t('drop-placeholder')"
                  :placeholder="identity.recto.value ? identity.recto.value.name : ''"
                  :state="identity.recto.state"
                  required
                  v-on:change="removeInvalidFeedback('recto')"
                  accept=".png, .jpeg, .jpg, .pdf">
                </b-form-file>
              </b-form-group>
              <b-form-group
                :label="$t('Verso')"
                label-for="verso-input"
                :invalid-feedback="identity.verso.invalidFeedback"
                class="mb-4">
                <b-form-file
                  class="custom-file"
                  id="verso-input"
                  :browse-text="$t('Select')"
                  v-model="identity.verso.value"
                  :drop-placeholder="$t('drop-placeholder')"
                  :placeholder="identity.verso.value ? identity.verso.value.name : ''"
                  :state="identity.verso.state"
                  required
                  v-on:change="removeInvalidFeedback('verso')"
                  accept=".png, .jpeg, .jpg, .pdf">
                </b-form-file>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100" variant="primary"  @click="handleSubmit()">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Validate') }}</span> <i class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  data() {
    return {
      identity: {
        recto:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        verso:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
      }
    };
  },

  mounted() {
    this.$forceUpdate()
  },

  methods: {
    handleSubmit(){
      let data = new FormData()
      data.append('identityRectoFile', this.identity.recto.value)
      data.append('identityVersoFile', this.identity.verso.value)

      api({
        method: "POST",
        url: '/user/sendIdentity',
        data: data
      })
        .then((response) => {
          this.$bvModal.hide('identity-to-validate-modal')
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.identity[invalidField]['state'] = false
            this.identity[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback (field) {
      this.identity[field]['state'] = null
    }
  },
};
</script>

<!-- not scoped car modal --><style>
#identity-to-validate-modal .modal-content,
#identity-to-validate-modal .modal-header,
#identity-to-validate-modal .modal-body,
#identity-to-validate-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.identity-to-validate-title{
  font-size: 34px!important;
  line-height: 40px !important;
  color: var(--main-red-medium) !important;
}

.identity-to-validate-subtitle{
  font-size: 24px;
}

.identity-to-validate-step-img{
  max-width: 200px;
}
.identity-to-validate-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.identity-to-validate-bg-veilleur {
  flex-shrink: 0;
  border-radius: 95px;
  background-color: var(--main-black-medium);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.identity-to-validate-step-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

.identity-to-validate-text{
  color: var(--main-grey-medium);
}

.identity-to-validate-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}
.identity-to-validate-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

.custom-file-label::after {
  background-color: var(--main-black-light) !important;
  color: var(--main-text-color) !important;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

@media (min-width: 992px) {
  .identity-to-validate-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .identity-to-validate-container img {
    order: 2;
    align-self: center;
  }
  .identity-to-validate-container {
    text-align: center;
  }
}

#identity-to-validate-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.margin-bottom-15{
  margin-bottom: -15px;
}

.identity-to-validate-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.identity-to-validate-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #identity-to-validate-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #identity-to-validate-modal .identity-to-validate-header {
    margin-top: 0px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #identity-to-validate-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #identity-to-validate-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #identity-to-validate-modal .modal-content {
    padding: 0;
    margin: 8px;
  }
  .identity-to-validate-header-content, .identity-to-validate-text, .identity-to-validate-container {
    padding: 10px;
  }
  .identity-to-validate-step-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #identity-to-validate-modal .modal-content {
    overflow: auto;
  }
  .identity-to-validate-title{
    font-size: 24px!important;
  }

  .identity-to-validate-subtitle{
    font-size: 18px;
  }
  .identity-to-validate-header-content, .identity-to-validate-text, .identity-to-validate-container {
    padding: 0px;

  }
}

</style>



// WEBPACK FOOTER //
// src/views/user/IdentityToValidateModal.vue